var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.timezone)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-chip',_vm._g({staticClass:"no-select",on:{"click":function($event){_vm.selected = _vm.selected + 1}}},on),[_c('v-avatar',[_c('v-icon',[_vm._v("mdi-clock")])],1),_vm._v("\n      "+_vm._s(_vm.timeString)+"\n    ")],1)]}}],null,false,1830438886)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.timezone))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56cf5cad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorldClock.vue
// module id = 626
// module chunks = 1